export default __webpack_public_path__ + "static/maxxton-c5227f6f88cd3b5c0960549c30d1f60f.svg";